module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAUCAYAAABMDlehAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAFElEQVQI12P4//+/LxMDAwMD7QgASZkDcVZ7i7wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/general-icons/separator_icon.png
// module id = 53
// module chunks = 0